(() => {
  const initImageDots = (root) => {
    const mainImage = root.querySelector("[data-bundle-xp-image]");
    const dots = root.querySelectorAll("[data-bundle-xp-dot]");
    if (!mainImage || !dots.length) return;

    for (const dot of dots) {
      if (dot.dataset.bundleDotInit === "true") continue;
      dot.dataset.bundleDotInit = "true";
      dot.addEventListener("click", () => {
        for (const d of dots) {
          d.classList.remove("active");
          d.setAttribute("aria-selected", "false");
        }
        dot.classList.add("active");
        dot.setAttribute("aria-selected", "true");
        const next = dot.getAttribute("data-image");
        if (next) mainImage.setAttribute("src", next);
      });
    }
  };

  const initTabs = (root) => {
    const groups = root.querySelectorAll("[data-bundle-xp-tabs]");
    for (const group of groups) {
      const tabs = Array.from(group.querySelectorAll("[data-bundle-xp-tab]"));
      const panels = Array.from(group.querySelectorAll("[data-bundle-xp-panel]"));
      if (!tabs.length || !panels.length) continue;

      const activateTab = (tab) => {
        for (const t of tabs) {
          t.classList.remove("is-active");
          t.setAttribute("aria-selected", "false");
          t.setAttribute("tabindex", "-1");
        }
        for (const panel of panels) {
          panel.classList.remove("is-active");
        }

        tab.classList.add("is-active");
        tab.setAttribute("aria-selected", "true");
        tab.setAttribute("tabindex", "0");
        const panelId = tab.getAttribute("aria-controls");
        if (!panelId) return;
        const panel = group.querySelector(`#${panelId}`);
        if (panel) panel.classList.add("is-active");
      };

      for (const tab of tabs) {
        if (tab.dataset.bundleTabInit === "true") continue;
        tab.dataset.bundleTabInit = "true";
        tab.addEventListener("click", () => activateTab(tab));
        tab.addEventListener("keydown", (event) => {
          const idx = tabs.indexOf(tab);
          if (event.key === "ArrowRight") {
            event.preventDefault();
            const next = tabs[(idx + 1) % tabs.length];
            activateTab(next);
            next.focus();
          }
          if (event.key === "ArrowLeft") {
            event.preventDefault();
            const prev = tabs[(idx - 1 + tabs.length) % tabs.length];
            activateTab(prev);
            prev.focus();
          }
        });
      }
    }
  };

  const initRoot = (root) => {
    if (!root || root.dataset.bundleXpInit === "true") return;
    root.dataset.bundleXpInit = "true";
    initImageDots(root);
    initTabs(root);
  };

  const initAll = (scope) => {
    const roots = (scope || document).querySelectorAll("[data-bundle-xp]");
    for (const root of roots) initRoot(root);
  };

  document.addEventListener("DOMContentLoaded", () => initAll(document));
  document.addEventListener("shopify:section:load", (event) => {
    if (event && event.target) initAll(event.target);
  });
})();
